import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/gua";

export default function FeaturedSection() {
  const featured = articles.filter((a) => a.featured).slice(0, 2);
  const hotList = [...articles].sort((a, b) => b.hot - a.hot).slice(0, 6);

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="热门合集"
          title="大家最近都在回看的合集"
          desc="被反复打开的那几个合集，通常信息最完整、时间线最清楚。先从这些开始补课，效率最高。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_360px]">
          <div className="flex flex-col gap-5">
            {featured.map((a) => (
              <ArticleCard key={a.id} article={a} variant="wide" />
            ))}
          </div>

          <aside className="rounded-xl border border-background-200 bg-background-50 p-5">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-fire-fill text-primary-500"></i>
                实时热度榜
              </h3>
              <Link
                to="/heji?sort=hot"
                className="text-xs text-foreground-500 transition-colors hover:text-primary-600"
              >
                全部 &gt;
              </Link>
            </div>
            <div className="mt-4 flex flex-col gap-2.5">
              {hotList.map((a, i) => (
                <ArticleCard key={a.id} article={a} variant="compact" rank={i + 1} />
              ))}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}